module.exports = __webpack_public_path__ + "img/img_throw_4@2x.aa80a0c0.png";